import { Injectable } from '@angular/core'
import { environment } from '@candidate/environments/environment'
import { TokenManagementService as Base } from '@engineering11/access-web'
import { getBaseSuffix, TokenStorage } from 'shared-lib'

@Injectable({ providedIn: 'root' })
export class TokenManagementService extends Base {
  constructor(tokenStorage: TokenStorage) {
    super({
      baseUrl: environment.services.access,
      token: () => tokenStorage.getAccessToken(),
      baseSuffix: getBaseSuffix(environment, 'access'),
    })
  }
}
